import { AnimationTriggerMetadata, trigger, style, state, transition, animate, query, stagger, keyframes } from '@angular/animations';

export const PopupAnimations: AnimationTriggerMetadata = trigger('inOutAnimation', [
  state('fade', style({ opacity: 1 })),
  transition('void => fade', [
    style({
      opacity: 1
    }),
    animate('0.5s ease-in')
  ]),
  transition('fade => void', [
    animate(
      '0.5s 0.1s ease-out',
      style({
        opacity: 0
      })
    )
  ]),

  state('slide-from-left', style({ opacity: 1, transform: 'translateX(0)' })),
  transition('void => slide-from-left', [
    style({
      opacity: 0,
      transform: 'translateX(-100%)'
    }),
    animate('0.5s ease-in')
  ]),
  transition('slide-from-left => void', [
    animate(
      '0.5s 0.1s ease-out',
      style({
        opacity: 0,
        transform: 'translateX(100%)'
      })
    )
  ]),

  state('slide-from-right', style({ opacity: 1, transform: 'translateX(0)' })),
  transition('void => slide-from-right', [
    style({
      opacity: 0,
      transform: 'translateX(100%)'
    }),
    animate('0.5s ease-in')
  ]),
  transition('slide-from-right => void', [
    animate(
      '0.5s 0.1s ease-out',
      style({
        opacity: 0,
        transform: 'translateX(-100%)'
      })
    )
  ]),

  state('slide-from-top', style({ opacity: 1, transform: 'translateY(0)' })),
  transition('void => slide-from-top', [
    style({
      opacity: 0,
      transform: 'translateY(-100%)'
    }),
    animate('0.5s ease-in')
  ]),
  transition('slide-from-top => void', [
    animate(
      '0.5s 0.1s ease-out',
      style({
        opacity: 0,
        transform: 'translateY(100%)'
      })
    )
  ]),

  state('slide-from-bottom', style({ opacity: 1, transform: 'translateY(0)' })),
  transition('void => slide-from-bottom', [
    style({
      opacity: 0,
      transform: 'translateY(100%)'
    }),
    animate('0.5s ease-in')
  ]),
  transition('slide-from-bottom => void', [
    animate(
      '0.5s 0.1s ease-out',
      style({
        opacity: 0,
        transform: 'translateY(-100%)'
      })
    )
  ]),

  state('scale', style({ opacity: 1, transform: 'scale(1)' })),
  transition('void => scale', [
    style({
      opacity: 0,
      transform: 'scale(0.4)'
    }),
    animate('0.4s ease-in')
  ]),
  transition('scale => void', [
    animate(
      '0.4s 0.1s ease-out',
      style({
        opacity: 0,
        transform: 'scale(0)'
      })
    )
  ])
]);
